<template>
  <div>
    <v-carousel height="auto" cycle show-arrows-on-hover hide-delimiter-background>
      <v-carousel-item v-for="(slide, i) in slides" :key="i">
        <v-row class="fill-height" align="center" justify="center">
          <v-img
            :src="slide.slide_image"
            class="tcdc-floor-image"
            aspect-ratio="1"
          />
        </v-row>
        <!-- </v-sheet> -->
      </v-carousel-item>
    </v-carousel>
    <p class="text-tcdc-green sub-header2 bold mt-4">{{ title }}</p>
    <div class="vhtml mb-5" v-html="content"></div>
    <GreenButton label="Book Now" v-if="enableButton" @onPress="onBooking"></GreenButton>
  </div>
</template>

<script>
  import GreenButton from "../buttons/GreenButton";
export default {
  components: {
    GreenButton
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    slides: {
      type: Array,
      default: null
    },
    enableButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onBooking() {
      this.$emit('onBooking');
    }
  },
  data: () => ({
    colors: [
      "indigo",
      "warning",
      "pink darken-2",
      "red lighten-1",
      "deep-purple accent-4"
    ],
    // slides: ["First", "Second", "Third", "Fourth", "Fifth"]
  })
};
</script>

<style>
.tcdc-floor-image {
  width: 100%;
  object-fit: contain;
}
</style>
